import get from 'lodash/get';

import { SavedFormData } from '../../shared/types';

export default function getSavedFormData(state: object) {
  return (get(state, 'eshop.offerSubscriptionForm.savedFormData') ||
    null) as SavedFormData;
}
